import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export function clientRequestAssignedToReducer(
	state = initialState.clientRequestAssignedTo,
	action
) {
	switch (action.type) {
		case types.GET_CLIENT_REQUESTS_EXTERNAL_USERS: {
			if (action.response?.clientGroups)
			{
				return {
					...state,
					clientGroups: action.response?.clientGroups,
					assignedMember: null
				};
			}
			if (action.response?.users)
			{
				return {
					...state,
					assignToUsers: action.response?.users,
					assignedMember: null
				};
			}
			return state;
		}
		case types.REASSIGN_REQUEST_BULK:
		case types.REASSIGN_REQUEST:
			return {
				...state,
				assignedMember: action.meta.api?.data?.clientUserId
					? action.meta.api.data.clientUserId
					: action.meta.api?.data?.clientGroupId
			};
			default:
			return state;
	}
}